module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-03-349234f5d2018b78d5c4158dc5e7f37d.svg";